// @flow
import React from 'react';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import usePageView from '../../hooks/usePageview';
import PoliciesPageWrapper from '../../components/Policies/PoliciesPageWrapper';
import TermsAndConditions from '../../components/Policies/TermsAndConditions';

export const TermsPage = () => {
  usePageView('terms-and-conditions');

  const { t } = useTranslation();

  return (
    <>
      <Helmet
        title={t('termsAndConditions:title', 'Terms and Conditions | JustPark')}
        titleTemplate="%s"
      />
      <PoliciesPageWrapper>
        <h1>{t('termsAndConditions:header', 'Terms and Conditions')}</h1>
        <TermsAndConditions />
      </PoliciesPageWrapper>
    </>
  );
};

export default TermsPage;
